import React, { useMemo, useState } from 'react'
import type { LayoutChangeEvent } from 'react-native'
import { View } from 'react-native'

import { HTMLRenderer } from '@ui-kit/components/HTMLRenderer'
import { theme } from '@ui-kit/theme'

const descriptionStyle = {
  color: theme.colors.grey500,
  fontFamily: theme.fontFamily.interRegular,
  fontSize: theme.fontSizes.sm,
  lineHeight: theme.lineHeights[6],
}

export const CoverageItemDescription = ({
  className,
  description,
}: {
  className?: string
  description: string
}) => {
  const [width, setWidth] = useState(0)
  const source = useMemo(() => ({ html: description }), [description])

  return (
    <View
      className={className}
      onLayout={(event: LayoutChangeEvent) => setWidth(event.nativeEvent.layout.width)}
    >
      <HTMLRenderer source={source} baseStyle={descriptionStyle} contentWidth={width} />
    </View>
  )
}
